import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import {Hydra1ChartJS} from "./Hydra1";

export class Hydra3ChartJS extends AlgoBase {

  constructor(target) {
    super("hydra", target, false);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Hydra3.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Chiller + Pump Energy (WITH AI)', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#E62B33',
        }, {
          label: 'Chiller + Pump Energy (WITHOUT AI)', // [dynamic value in loadDataset()],
          data: this.algortihmData.withoutAIDatasets[0],
          borderColor: '#000000',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 3),
          y: {
            min: 50,
            max: 650,
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' kW'; // Append the unit
              }
            },
          }
        },
        plugins: {
          title: {
            display: true,
            text: '-', // [dynamic value in loadDataset()],
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    this.chart.data.datasets[1].data = this.algortihmData.withoutAIDatasets[datasetIndex];

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 3);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(1, 3);

    this.chart.options.plugins.title.text = this.getLegendFromCMS(3, 3)?.toUpperCase();

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 1);
    const withoutAIDatasets = singleDataSetBuild.mainDatasets.splice(singleDataSetBuild.mainDatasets.length / 2)
    return {
      labels: singleDataSetBuild.labels,
      mainDatasets: singleDataSetBuild.mainDatasets,
      withoutAIDatasets: withoutAIDatasets,
    };
  }

}
